import { Box, Skeleton, styled } from "@mui/material";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
}));

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(1.2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const ItemCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.2),
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
}));

export const RoutingConfigurationSkeleton = () => {
  const rows = [1, 2, 3];

  return (
    <Wrapper>
      {rows.map((row) => (
        <Row key={row}>
          <Side>
            <Skeleton width={140} height={20} />
            <Skeleton width={180} height={16} />
          </Side>

          <Grid>
            {[1, 2, 3, 4].map((item) => (
              <ItemCard key={item}>
                <Skeleton width={40} height={10} />
                <Skeleton width="80%" height={14} />
              </ItemCard>
            ))}
          </Grid>
        </Row>
      ))}
    </Wrapper>
  );
};
